import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { withRouter } from 'react-router'
import { admin } from 'routes/route.map'
import { withTableController } from 'shared/hooks'
import { StoreContext } from 'store/context'

import UpdateButtonComponent from './component'

export const Update = combine({
  hocs: [withRouter],
  hooks: [
    withTableController({ id: 'tournament-table' }),
    withContext('appStore', StoreContext),
    withCallbacks(
      {
        onRouteToUpdateEditForm:
          (_state, { value, history }) =>
          () => {
            history.push(admin.tournaments.update.view(value.id))
          },
      },
      ['value']
    ),
  ],
})(UpdateButtonComponent)
